<!--
 * @FilePath: /netHallOfficialAccounts/src/views/Business/Expand/index.vue
-->
<template>
  <div class="notice">
    <div class="notice-head">
      <van-field class="block-field btn" label="申请表" name="businessType" readonly>
          <template #input>
            <div class="download">
              <van-button plain type="info" style="height: 40px;" native-type="button" @click="download('applyFile', '申请表')">
                申请表下载
              </van-button>
            </div>
          </template>
        </van-field>
    </div>
    <div class="notice-content">
      <div v-html="noticeHtml"></div>
    </div>
    <div class="notice-foot">
      <div class="notice-foot-left">
        <!-- <van-checkbox v-model="checked" shape="square" icon-size="20px">已阅读</van-checkbox> -->
      </div>
      <div class="notice-foot-right">
        <van-button class="nfr-button" :disabled="false" type="info" @click="verification">
          下一步
        </van-button>
      </div>
    </div>
  </div>
</template>

<script>
import store from '@/store';
import { mapState } from 'vuex';
import { Toast } from 'vant';
import { termsReckon } from '@/utils/businessRoute';
import { getCustReadingByCode, verification } from '@/api/business';
import serverconfig from "@/api/server.config";
const DOWNURL = serverconfig.DOWNURL;

export default {
  data() {
    return {
      businessSubclassData: null,
      businessType: '',
      businessSubclass: '',
      moduleCode: '',
      moduleName: '',
      checked: false,
      custReadingData: null,
      noticeHtml: null,
      contentPerson: "<div id=\"u17\" class=\"ax_default label\">\n<div id=\"u17_text\" class=\"text \">\n<p><span style=\"font-size: 14px;\"><strong><span style=\"color: #000000;\">报装须知</span><br /></strong></span></p>\n</div>\n</div>\n<div class=\"ax_default label\"><strong><span style=\"font-size: 14px; color: #000000;\">申报材料</span></strong></div>\n<div class=\"ax_default label\">\n<div class=\"ax_default label\"><span style=\"font-size: 14px; color: #969fa9;\">* 《申请表》</span></div>\n</div>\n<div class=\"ax_default label\"><span style=\"font-size: 14px; color: #969fa9;\">* 申请用水之前请先点击下载申请附件，盖章后拍照上传。</span></div>\n<div class=\"ax_default label\">&nbsp;</div>\n<div id=\"u19\" class=\"ax_default\" data-left=\"25\" data-top=\"321\" data-width=\"325\" data-height=\"206\">\n<div id=\"u23\" class=\"ax_default _文本段落\">\n<div id=\"u23_text\" class=\"text \">\n<div class=\"ax_default label\"><span style=\"font-size: 14px; color: #000000;\"><span style=\"font-size: 14px;\"><strong>注意事项</strong></span></span></div>\n\n<div class=\"ax_default label\"><span style=\"font-size: 14px; color: #969fa9;\"><span style=\"font-family: symbol;\">① </span>《居民用水申请表》用户自行打印，表内各项信息填写完整，用水客户签字处签字按手印，村委会及镇政府盖公章；<br /></span></div>\n<div class=\"ax_default label\"><span style=\"font-size: 14px; color: #969fa9;\"><span style=\"font-family: symbol;\">② </span>业务受理成功后，请保持手机畅通，工作人员将联系您进行现场勘查、缴费、签订合同事宜。<br /></span></div>\n<div class=\"ax_default label\">&nbsp;</div>\n<div class=\"ax_default label\"><span style=\"font-size: 14px; color: #000000;\"><span style=\"font-size: 14px;\"><strong>办理流程</strong></span></span></div>\n<div class=\"ax_default label\"><span style=\"font-size: 14px; color: #969fa9;\"><span style=\"font-family: symbol;\">① </span>提交申报材料至所属水厂<br /></span></div>\n<div class=\"ax_default label\"><span style=\"font-size: 14px; color: #969fa9;\"><span style=\"font-family: symbol;\">② </span>资料审核（如未通过需补交资料）<br /></span></div>\n<div class=\"ax_default label\"><span style=\"font-size: 14px; color: #969fa9;\"><span style=\"font-family: symbol;\">③ </span>现场勘查，确定用水方案</span></div>\n<div class=\"ax_default label\"><span style=\"font-size: 14px; color: #969fa9;\"><span style=\"font-family: symbol;\">④</span> 编制工程预算书<br /></span></div>\n<div class=\"ax_default label\"><span style=\"font-size: 14px; color: #969fa9;\"><span style=\"font-family: symbol;\">⑤ </span>用户缴费并签订供水合同</span></div>\n<div class=\"ax_default label\"><span style=\"font-size: 14px; color: #969fa9;\"><span style=\"font-family: symbol;\">⑥</span>设计施工</span></div>\n<div class=\"ax_default label\"><span style=\"font-size: 14px; color: #969fa9;\"><span style=\"font-family: symbol;\">⑦</span>验收通水</span></div>\n<div class=\"ax_default label\"><span style=\"font-size: 14px; color: #969fa9;\"><span style=\"font-family: symbol;\">⑧</span>办理水卡</span></div>\n<div class=\"ax_default label\">&nbsp;</div>\n</div>\n</div>\n</div>\n<div id=\"u33\" class=\"ax_default _文本段落\">\n<div id=\"u33_div\" class=\"\"></div>\n<div id=\"u33_text\" class=\"text \">\n<div class=\"ax_default label\"><span style=\"font-size: 14px; color: #000000;\"><span style=\"font-size: 14px;\"><strong>申请人声明</strong></span></span></div>\n<div class=\"ax_default label\"><span style=\"font-size: 14px; color: #969fa9;\">本人已阅读并了解办事指南告知内容，同时承诺所提供资料真实有效。</span></div>\n</div>\n</div>\n<div class=\"ax_default label\">&nbsp;</div>",
      // contentCompany: "<div id=\"u17\" class=\"ax_default label\">\n<div id=\"u17_text\" class=\"text \">\n<p><span style=\"font-size: 14px;\"><strong><span style=\"color: #000000;\">非居民客户报装须知</span><br /></strong></span></p>\n</div>\n</div>\n<div class=\"ax_default label\"><strong><span style=\"font-size: 14px; color: #000000;\">申报材料</span></strong></div>\n<div class=\"ax_default label\">\n<div class=\"ax_default label\"><span style=\"font-size: 14px; color: #969fa9;\">* 《非居民用水申请表》，《营业执照》，《法人身份证》，《非居民用户用水报装告知书》，《产权有效证明》，《项目批复文件》</span></div>\n</div>\n<div class=\"ax_default label\"><span style=\"font-size: 14px; color: #969fa9;\">* 以上所有文件需用户签字确认。</span></div>\n<div class=\"ax_default label\"><span style=\"font-size: 14px; color: #969fa9;\">* 以下产权证明材料均可办理相关手续，但以排序作为优先级，前置材料有权覆盖后置材料。</span></div>\n<div class=\"ax_default label\"><span style=\"font-size: 14px; color: #969fa9;\"><span style=\"font-family: symbol;\">① </span>产权证或《房地产交易中心备案登记证明》；<br /></span></div>\n<div class=\"ax_default label\"><span style=\"font-size: 14px; color: #969fa9;\"><span style=\"font-family: symbol;\">② </span>省、市、区政府对暂未办理产权的合规用地的批示文件；<br /></span></div>\n<div class=\"ax_default label\">&nbsp;</div>\n<div id=\"u19\" class=\"ax_default\" data-left=\"25\" data-top=\"321\" data-width=\"325\" data-height=\"206\">\n<div id=\"u23\" class=\"ax_default _文本段落\">\n<div id=\"u23_text\" class=\"text \">\n<div class=\"ax_default label\"><span style=\"font-size: 14px; color: #000000;\"><span style=\"font-size: 14px;\"><strong>注意事项</strong></span></span></div>\n\n<div class=\"ax_default label\"><span style=\"font-size: 14px; color: #969fa9;\"><span style=\"font-family: symbol;\">① </span>《非居民用水申请表》用户自行打印，表内各项信息填写完整，用水客户签章处加盖企业公章，经办人签字处签字按手印（法定代表人签字），村委会及镇政府盖章；如代办，经办人签字处由代办人签字按手印，提供经办人身份证复印件加盖公章，填写授权委托书盖公章。<br /></span></div>\n<div class=\"ax_default label\"><span style=\"font-size: 14px; color: #969fa9;\"><span style=\"font-family: symbol;\">② </span>业务受理成功后，请保持手机畅通，工作人员将联系您进行现场勘查、缴费、签订合同事宜。<br /></span></div>\n<div class=\"ax_default label\">&nbsp;</div>\n<div class=\"ax_default label\"><span style=\"font-size: 14px; color: #000000;\"><span style=\"font-size: 14px;\"><strong>办理流程</strong></span></span></div>\n<div class=\"ax_default label\"><span style=\"font-size: 14px; color: #969fa9;\"><span style=\"font-family: symbol;\">① </span>提交申报材料至所属水厂<br /></span></div>\n<div class=\"ax_default label\"><span style=\"font-size: 14px; color: #969fa9;\"><span style=\"font-family: symbol;\">② </span>资料审核（如未通过需补交资料）<br /></span></div>\n<div class=\"ax_default label\"><span style=\"font-size: 14px; color: #969fa9;\"><span style=\"font-family: symbol;\">③ </span>现场勘查，确定用水方案</span></div>\n<div class=\"ax_default label\"><span style=\"font-size: 14px; color: #969fa9;\"><span style=\"font-family: symbol;\">④</span> 编制工程预算书<br /></span></div>\n<div class=\"ax_default label\"><span style=\"font-size: 14px; color: #969fa9;\"><span style=\"font-family: symbol;\">⑤ </span>用户缴费并签订供水合同</span></div>\n<div class=\"ax_default label\"><span style=\"font-size: 14px; color: #969fa9;\"><span style=\"font-family: symbol;\">⑥</span>设计施工</span></div>\n<div class=\"ax_default label\"><span style=\"font-size: 14px; color: #969fa9;\"><span style=\"font-family: symbol;\">⑦</span>验收通水</span></div>\n<div class=\"ax_default label\"><span style=\"font-size: 14px; color: #969fa9;\"><span style=\"font-family: symbol;\">⑧</span>办理水卡</span></div>\n<div class=\"ax_default label\">&nbsp;</div>\n</div>\n</div>\n</div>\n<div id=\"u33\" class=\"ax_default _文本段落\">\n<div id=\"u33_div\" class=\"\"></div>\n<div id=\"u33_text\" class=\"text \">\n<div class=\"ax_default label\"><span style=\"font-size: 14px; color: #000000;\"><span style=\"font-size: 14px;\"><strong>申请人声明</strong></span></span></div>\n<div class=\"ax_default label\"><span style=\"font-size: 14px; color: #969fa9;\">本人已阅读并了解办事指南告知内容，同时承诺所提供资料真实有效。</span></div>\n</div>\n</div>\n<div class=\"ax_default label\">&nbsp;</div>",
    };
    
  },
  computed: {
    ...mapState('user', {
      homeInfo: (state) => state.homeInfo,
      businessNews: (state) => state.businessNews,
    }),
    businessTerms() {
      return termsReckon('0001');
    },
  },
  mounted() {
    this.into();
  },
  methods: {
    download(name, file) {
      let filename = name;
      let a = document.createElement("a");
      let realFilename = encodeURIComponent(filename);
      a.href = realFilename + ".xlsx";
      //路径中'/'为根目录，即index.html所在的目录
      a.download = file + ".xlsx";
      a.click();
    },
    async into() {
      // this.businessEvent(this.businessTerms.child[0]);
    },
    businessEvent(data) {
      console.log(data);
      this.checked = false;
      this.businessType = data.code;
      if (data.child !== undefined && data.child.length > 0) {
        this.businessSubclassData = data.child;
        this.businessSubclass = '';
        this.moduleCode = '';
        this.noticeHtml = this.contentCompany;
      } else {
        this.businessSubclassData = null;
        this.businessSubclass = '';
        this.moduleCode = data.code;
        this.moduleName = data.name;
        this.getReadingByCode();
      }
    },
    selectBusinessSubclass(data) {
      this.checked = false;
      this.businessSubclass = data.code;
      this.moduleCode = data.code;
      this.moduleName = data.name;
      this.getReadingByCode();
    },
    /* 获取用户须知 */
    async getReadingByCode() {
      let data = { businessCode: this.businessTerms.code, moduleCode: this.moduleCode };
      console.log(data);
      let res = await getCustReadingByCode(data);
      let { status, resultData } = res;
      if (status === 'complete' && resultData) {
        this.custReadingData = resultData;
        // this.noticeHtml = resultData.content;
        if(this.moduleCode == '000101') {
            this.noticeHtml = this.contentPerson;
        } else {
            this.noticeHtml = this.contentCompany;
        }
      } else {
        this.custReadingData = null;
        this.noticeHtml = null;
      }
    },
    async nextStep() {
      // if (this.businessType) {
        let data = {
          businessState: 'add',
          // businessCode: this.businessTerms.code,
          // moduleCode: this.moduleCode,
          busHandlingId: null,
          // custReadingId: this.custReadingData.custReadingId,
          // moduleName: this.businessTerms.name + ' - ' + this.moduleName,
        };
        await store.dispatch('user/setBusinessNews', data);
        this.$router.push({ path: '/Expand/InstallWater' });
      // } else {
      //   Toast.fail('请选择客户类型');
      // }
    },
    // 校验后进入下一步
    async verification() {
      this.nextStep();
      // let arg = {
      //   moduleCode: this.moduleCode,
      // };
      // const { status, resultData } = await verification(arg);
      // if (status === 'complete') {
      //   this.nextStep();
      // }
    },
  },
};
</script>

<style lang="less" scoped>
.notice {
  display: flex;
  flex-direction: column;
  .notice-head-radio {
    margin: 6px 20px 6px 0;
  }
  .notice-content {
    background: #ffffff;
    margin: 16px 0 80px 0;
    padding: 0 16px;
    overflow: hidden;
    /deep/ ul {
      display: block;
      list-style-type: disc;
      margin-block-start: 1em;
      margin-block-end: 1em;
      margin-inline-start: 0px;
      margin-inline-end: 0px;
      padding-inline-start: 40px;
    }
    /deep/ ul ul {
      list-style-type: circle;
      margin-block-start: 0px;
      margin-block-end: 0px;
    }
    /deep/ul ul ul {
      list-style-type: square;
    }
    /deep/ol {
      list-style: decimal inside;
      padding-left: 40px;
      margin: 16px 0;
    }
  }
  .notice-foot {
    width: 100%;
    height: 64px;
    position: fixed;
    bottom: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: #ffffff;
    border-top: 1px solid #ebedf0;
    .notice-foot-left {
      margin-left: 16px;
      font-family: PingFangSC-Regular;
      font-size: 14px;
      color: rgba(0, 0, 0, 0.65);
    }
    .notice-foot-right {
      margin-right: 16px;
      .nfr-button {
        width: 110px;
        height: 40px;
        background: #1d6fe9;
        border-radius: 4px;
        font-family: PingFangSC-Medium;
        font-size: 14px;
        color: #ffffff;
      }
    }
  }

  /deep/ .van-field__label {
    line-height: 40px;
  }
}
</style>
